export const STAGE_CHOOSE_ROUTE = 0
export const STAGE_CHOOSE_SERVICE = 1
export const STAGE_EDIT_SERVICE = 2
export const STAGE_ADD_STEP = 3
export const STAGE_ADD_SERVICE = 4
export const STAGE_SUMMARY = 5

export const stages = {
    [STAGE_CHOOSE_ROUTE]: {
        step: 1,
        title: 'booking.choose_path'
    },
    [STAGE_CHOOSE_SERVICE]: {
        step: 2,
        title: 'Choix du service'
    },
    [STAGE_EDIT_SERVICE]: {
        step: 3,
        title: 'Service'
    },
    [STAGE_ADD_STEP]: {
        step: 4,
        title: 'Ajouter une étape'
    },
    [STAGE_ADD_SERVICE]: {
        step: 4,
        title: 'Ajouter un service'
    },
    [STAGE_SUMMARY]: {
        step: 5,
        title: 'Summary'
    }
}

export const getStage = (stage) => {
    return stages[stage]
}

export const getStageCount = () => Math.max(...Object.keys(stages).map(stageIndex => stages[stageIndex].step))